<template>
  <q-dialog
    ref="addressPersonModal"
    @show="onShowHandler"
    @hide="onHideHandler"
  >
    <q-layout
      view="Lhh lpR fff"
      container
      class="bg-white modal-large addressPersonContainer"
    >
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            <q-icon name="library_add" size="25px" class="q-pr-sm" />
            {{ $gettext(computedTitle) }}
          </q-toolbar-title>
          <q-btn flat @click="hide">
            <q-icon name="cancel" size="2.5em"/>
          </q-btn>
        </q-toolbar>
      </q-header>
      <jt-dynamic-form
        v-if="renderForm"
        ref="compositionForm"
        :inputs="form.inputs"
        :interface="form.nmInterface"
        :relacionamentos="form.relacionamentos"
        :model="form.dadosForm"
        form-class="form"
        class="q-pa-lg formContainer addressPersonForms"
        @search-found="selections"
      />
      <section
        class="row justify-center full-width q-gutter-md q-pa-lg sectionAddressPerson"
      >
        <div
          v-for="(button, index) in form.buttons"
          :key="index"
          class="col-2 buttonsAddressPerson"
        >
          <q-btn
            class="full-width"
            color="positive"
            :name="button.name"
            @click="onFormButtonClickHandler(button)"
            >{{ button.label }}
          </q-btn>
        </div>
      </section>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDynamicForm, JtCompositionFormModal } from 'jtech-webcomps'
import { repository } from 'jtech'
import {
  QDialog,
  QLayout,
  QIcon,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QBtn,
  QTab,
  QTabPanel,
  QTabPanels
} from 'quasar'
import { remove } from 'mobx'
@Component({
  mixins: [JtCompositionFormModal],
  components: {
    JtDynamicForm,
    QDialog,
    QLayout,
    QIcon,
    QToolbar,
    QHeader,
    QToolbarTitle,
    QBtn,
    QTab,
    QTabPanel,
    QTabPanels
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    composicaos: {
      type: Array,
      required: true
    },
    nrLinhaSelecionada: Number,
    flComposicaoAlteracao: Boolean
  }
})
class AddressPerson extends Vue {
  renderForm = false;
  formModel = {};
  show () {
    this.renderForm = true
    this.form.inputs = this.form.inputs.filter((i) => i.type != 'COMPOSICAO')
    this.formModel = this.form.dadosForm

    this.$refs.addressPersonModal.show()
  }

  hide () {
    this.$refs.addressPersonModal.hide()
  }

  async selections (data) {
    if (data.address.idField) {
      const param = { id: data.address.idField }
      const { registros } = await repository.resolveDatatableModel(
        'address.pesquisarSelecao',
        param
      )

      this.$nextTick(() => {
        this.form.dadosForm.address = data.address.idField
        this.$set(this.form.dadosForm, 'zipCode', registros[0].zipCode)
        this.$set(
          this.form.dadosForm,
          'neighborhood',
          registros[0].neighborhood
        )
        this.$set(this.form.dadosForm, 'city', registros[0].city)
        this.$set(this.form.dadosForm, 'state', registros[0].state)
        this.$set(this.form.dadosForm, 'country', registros[0].country)
      })
    }
  }

  setEditable (object) {
    if (object.id) object.flAlterado = 'S'
  }

  onFormButtonClickHandler (button) {
    if (button.name === 'btSalvarComposicao') {
      this.__saveButtonHandler({ button, fields: this.formModel })
    } else if (button.name === 'btFecharComposicao') this.hide()
  }
}
export default AddressPerson
</script>
<style lang="stylus" >
@import '~quasar-variables';

.addressPersonContainer {
  border-radius: 0px !important;
}

.addressPersonForms {
  #scroll-area {
    height: calc(55vh - 12px) !important;
  }
}

.addressPersonForms .q-scrollarea {
  margin-top: 20px
}

.sectionAddressPerson {
  .buttonsAddressPerson:first-child {
    .q-btn {
      background: #A9B9C2 !important;
      color: black;
    }
  }
}

@media only screen and (max-height: 765px) {
  .addressPersonForms {
    #scroll-area {
      height: calc(50vh - 12px) !important;
    }
  }
}
</style>
